import styled from 'styled-components';

/**
 * Card lila contenedora del grid de multimedia. Mismo patrón que el
 * `Container` canónico de `ActionContentCardResume` (lila + padding xl +
 * border-radius 0.8rem) para mantener el lenguaje visual del resto del
 * sistema. En tablet/móvil el padding se reduce para dejar más sitio al
 * grid de miniaturas.
 */
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s};
  width: 100%;
  padding: ${({ theme }) => theme.spacing.xl};
  background-color: ${({ theme }) => theme.colors.backgroundLila};
  border-radius: 0.8rem;

  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spacing.m};
  }
`;
